import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faEdit, faHashtag, faPercentage, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        arrayResultado: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.arrayResultado;
        state[e.target.name] = e.target.value;
        this.setState({ arrayResultado: state });
         this.Calcular();

    };
    Calcular = () =>{
        var valor_unitario = document.getElementById('valor_compra').value;
        var iva = document.getElementById('iva').value;
        var utilidad = document.getElementById('utilidad').value;
        var total1 = 0;
        var total2 = 0;
        var total = 0;
        if(valor_unitario!='' || valor_unitario!=0){
            if(iva!='' || iva!=0){
                total1 = valor_unitario * (iva/100);  
                console.log(valor_unitario+ ' total1 '+total1);   
            }
            if(utilidad!='' || utilidad!=0){
                total2 = (parseFloat(valor_unitario) + parseFloat(total1)) * ((utilidad/100)+1);
                console.log('total2 '+total2);
            }
            total = parseFloat(total2);
        }
        document.getElementById('valor_unitario').value = total;
        document.getElementById('valor_real').value = total;
        console.log(total);
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const tipo_mp = document.getElementById('TIPO').value;
        const codigo = document.getElementById('codigo').value;
        const nombre = document.getElementById('nombre').value;
        const codigo_siesa = document.getElementById('codigo_siesa').value;
        const ID_TIPO_UNIDAD = document.getElementById('ID_TIPO_UNIDAD').value;
        const valor_unitario = document.getElementById('valor_unitario').value;
        const valor_compra = document.getElementById('valor_compra').value;
        const iva = document.getElementById('iva').value;
        const valor_real = document.getElementById('valor_real').value;
        const utilidad = document.getElementById('utilidad').value;
        const categoria = document.getElementById('categoria').value;
        var errores = [];
        if (!tipo_mp) { errores.push("error_tipo_mp"); }
        if (!categoria) { errores.push("error_categoria"); }
        if (!codigo) { errores.push("error_codigo"); }
        if (!nombre) { errores.push("error_nombre"); }
        if (!codigo_siesa) { errores.push("error_codigo_siesa"); }
        if (!ID_TIPO_UNIDAD) { errores.push("error_id_tipo_unidad"); }
        if (!valor_unitario) { errores.push("error_valor_unitario"); }
        if (!valor_compra) { errores.push("error_valor_compra"); }
        if (!iva) { errores.push("error_iva"); }
        if (!valor_real) { errores.push("error_valor_real"); }
        if (!utilidad) { errores.push("error_utilidad"); }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        Swal.showLoading();
        authAxios.post("materiales/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Materiales!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterMateriales");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("materiales/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, arrayResultado: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, arrayResultado } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR MATERIAL</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className='row'>
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                            <div className="col-md-2">
                                                    <label htmlFor="categoria">Categoria</label>
                                                    <select name="categoria"
                                                        id="categoria"
                                                        className={((this.verificarError("error_categoria")) ? "is-invalid" : "") + " form-select form-select-sm"} 
                                                        value={arrayResultado.CATEGORIA}
                                                        options={arrayResultado.CATEGORIA}
                                                         onChange={this.cambioValor}>
                                                        <option value="">Seleccione la categoria</option>
                                                        <option value="1">LUMINARIA</option>
                                                        <option value="2">CABLE</option>
                                                        <option value="3">POSTES</option>
                                                        <option value="4">HERAJERIA + ALL</option>
                                                        <option value="5">TRANSFORMADOR</option>
                                                        <option value="6">MANO DE OBRA</option>
                                                        <option value="7">TRANSPORTE</option>
                                                        <option value="8">EQUIPO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo</small>
                                                </div>
                                            <div className="col-md-2">
                                                    <label htmlFor="TIPO">Tipo MP</label>
                                                    <select name="TIPO"
                                                        id="TIPO"
                                                        value={arrayResultado.TIPO}
                                                        options={arrayResultado.TIPO}
                                                        className={((this.verificarError("error_tipo_mp")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el tipo</option>
                                                        <option value="MAT">Material (MAT)</option>
                                                        <option value="MO">Mano Obra (MO)</option>
                                                        <option value="EQP">Equipo (EQP)</option>
                                                        <option value="TRA">Transporte (TRA)</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="codigo">Código</label>
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="codigo" id="codigo" defaultValue={arrayResultado.CODIGO}
                                                            className={((this.verificarError("error_codigo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Código" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Código</small>
                                                    </div>
                                                </div>
                                               
                                                <div className="col-md-6">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={arrayResultado.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Nombre" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Material</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="codigo_siesa">Código Siesa</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="codigo_siesa" id="codigo_siesa" defaultValue={arrayResultado.COD_SIESA}
                                                            className={((this.verificarError("error_codigo_siesa")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Código Siesa" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Código Siesa</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="ID_TIPO_UNIDAD">Unidad</label>
                                                    <select name="ID_TIPO_UNIDAD"
                                                        id="ID_TIPO_UNIDAD"
                                                        value={arrayResultado.ID_TIPO_UNIDAD}
                                                        options={arrayResultado.ID_TIPO_UNIDAD}
                                                        className={((this.verificarError("error_id_tipo_unidad")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Unidad</option>
                                                        <option value="1">Global (GLB)</option>
                                                        <option value="2">Metros (M)</option>
                                                        <option value="3">Rollo</option>
                                                        <option value="4">Unidad (UND)</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Unidad</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_compra">Valor Compra</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor_compra" id="valor_compra" defaultValue={arrayResultado.VALOR_COMPRA}
                                                            className={((this.verificarError("error_valor_compra")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Compra" aria-describedby="helpId"
                                                            onChange={this.Calcular}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Compra</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="iva">I.V.A.</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="iva" id="iva" defaultValue={arrayResultado.IVA}
                                                            className={((this.verificarError("error_iva")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="I.V.A." aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el I.V.A.</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="utilidad">Utilidad</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="utilidad" id="utilidad" defaultValue={arrayResultado.UTILIDAD}
                                                            className={((this.verificarError("error_utilidad")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Utilidad" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite la Utilidad</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_unitario">Valor Unitario</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor_unitario" id="valor_unitario" defaultValue={arrayResultado.VALOR_UNITARIO}
                                                            className={((this.verificarError("error_valor_unitario")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Unitario" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Unitario</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_real">Valor Venta</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor_real" id="valor_real" defaultValue={arrayResultado.VALOR_REAL}
                                                            className={((this.verificarError("error_valor_real")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Real" aria-describedby="helpId"
                                                             onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Real</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Material</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterMateriales"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;